import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "button--back",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
  }, [
    _createVNode(_component_SvgIcon, {
      class: "icon icon--medium",
      local: "",
      src: require('./images/arrow-down.svg')
    }, null, 8, ["src"]),
    _createElementVNode("span", null, _toDisplayString(_ctx.$t("buttons.previous")), 1)
  ]))
}